/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ProfileUpdateAliases {
  LAYOUT_PROFILE_CONTENT = 'layout-profile-content',
  PANEL_PROFILE = 'panel-profile',
  PROFILE_FRAGMENT = 'profile-fragment',
  PROFILE_UPDATE_CHECK_ACTION = 'profile-update-check-action',
  PROFILE_UPDATE_CONTEXTUAL_BAR = 'profile-update-contextual-bar',
  PROFILE_UPDATE_LAYOUT = 'profile-update-layout',
  PROFILE_UPDATE_PANEL = 'profile-update-panel',
  TOAST_NOTIFICATION = 'toast-notification',
}
export { ProfileUpdateAliases };
